import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CardOnboardingResponse } from '../../../../queries/pxtraCard';
import { onboardingOutcome } from './sentence';

// Module-level on purpose: the app bar remounts on some navigations, and a
// ref would forget the last stand exactly when the poll brings the new one.
const lastSeen = new Map<string, CardOnboardingResponse>();

/**
 * Tells the manager when Swan has decided, wherever in the dashboard they
 * are. The notices on the card pages simply disappear at that point, so
 * without this a verification goes unannounced.
 */
export const useOnboardingOutcomeNotice = (
  companyId: string,
  onboarding?: CardOnboardingResponse
): void => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!onboarding || !companyId) return;

    const outcome = onboardingOutcome(lastSeen.get(companyId), onboarding);
    lastSeen.set(companyId, onboarding);

    if (outcome === 'verified') {
      enqueueSnackbar(t('pxtraCard:onboardingVerifiedNotice'), { variant: 'success' });
    }

    if (outcome === 'refused') {
      enqueueSnackbar(t('pxtraCard:onboardingRefusedNotice'), { variant: 'error' });
    }
  }, [companyId, onboarding, enqueueSnackbar, t]);
};
